<script setup lang="ts">
import { inject } from 'vue';

import { Ellipsis, Trash2 } from 'lucide-vue-next';

import {
  CustomDropdownMenu,
  CustomDropdownMenuItem
} from '@/components/custom/CustomDropdownMenu';
import { Button } from '@/components/ui/Button';

import EditIcon from 'assets/icons/edit-05.svg?component';

import {
  openDeleteTokenModal,
  openEditTokenModal
} from '@/lib/modals/tokensModals';

import { BUTTON_VARIANTS } from '@/constants/component';

import type { UseModal } from '@/types/modals';
import type { ListToken } from '@/types/tokens';

defineProps<{
  token: ListToken;
}>();

const openModal = inject('openModal') as UseModal['openModal'];
</script>

<template>
  <div class="flex justify-center" @click.stop>
    <CustomDropdownMenu>
      <template #trigger>
        <Button
          type="button"
          :variant="BUTTON_VARIANTS.icon"
          test-id="advanced-table-dropdown-button"
        >
          <Ellipsis class="w-6 h-6 text-gray-800" />
        </Button>
      </template>
      <template #menu-options>
        <CustomDropdownMenuItem
          :item-label="$t('manageTokens.edit_token')"
          item-class="stroke-1"
          test-id="tokens-actions-edit-token-button"
          :item-icon="EditIcon"
          @click="openEditTokenModal(openModal, token)"
        />
        <CustomDropdownMenuItem
          class="text-red-500"
          test-id="tokens-actions-delete-token-button"
          :item-label="$t('manageTokens.delete_token_title')"
          :item-icon="Trash2"
          @click="openDeleteTokenModal(openModal, token)"
        />
      </template>
    </CustomDropdownMenu>
  </div>
</template>
